import {combineEpics} from 'redux-observable'
import {userEpics} from 'features/User'
import {settingsEpics} from 'features/Settings'
import {endpointsEpics} from 'features/Endpoints/endpointsEpics'
import {policiesEpics} from 'features/Policies/policiesEpics'
import {analyticsOverviewEpics} from 'features/Analytics/Overview/analyticsOverviewEpic'
import {analyticsLogsDownloadEpics} from 'features/Analytics/Downloads/AnalyticsLogs/epics'
import {violationsLogsDownloadEpics} from 'features/Analytics/Downloads/ViolationsLogs/epics'

export default combineEpics(
  ...userEpics,
  ...settingsEpics,
  ...endpointsEpics,
  ...policiesEpics,
  ...analyticsOverviewEpics,
  ...analyticsLogsDownloadEpics,
  ...violationsLogsDownloadEpics,
)
